/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { FinalizeGiftClaimResponse, FinalizeGiftClaimVars } from '../openapi-types.gen.js';

export type { FinalizeGiftClaimResponse, FinalizeGiftClaimVars } from '../openapi-types.gen.js';

export const useFinalizeGiftClaim = createMutationHook<FinalizeGiftClaimVars, FinalizeGiftClaimResponse, unknown>({
  specName: 'useFinalizeGiftClaim',
  path: '/v1/gifts/claim/finalize',
  method: 'POST',
  resolveUrl: (vars: FinalizeGiftClaimVars) => `/v1/gifts/claim/finalize`,
  buildBody: (vars: FinalizeGiftClaimVars) => ({ giftPda: vars.giftPda, signature: vars.signature, claimerWallet: vars.claimerWallet }),
  parseResponse: (raw: unknown): FinalizeGiftClaimResponse => raw as FinalizeGiftClaimResponse,
  
  
  
});
